module.exports = __webpack_public_path__ + "img/undraw_doctor_kw-5-l.874a5919.svg";